import { FaUserAltSlash } from "react-icons/fa";

export default FaUserAltSlash;